import axios from 'axios'

export const auth = {
    state:{
        token: localStorage.getItem("token") || '',
        logindetails: {},
        regDetails: {},
        isUserLogged:false
    },
    mutations:{
        Login(state,token){
          state.token = token
          state.isUserLogged = true
        },
        Logout(state){
          state.isUserLogged = false
        },
        LoginDetails(state, data){
          state.logindetails = data
        },
        RegDetails(state, payload){
          state.regDetails = payload
        }
    },
    actions:{
      Login: ({commit}, payload) => {
          return new Promise((resolve, reject)=>{
            axios.post("/authenticateuser",payload)
            .then(({data, status})=>{
              if(status === 200){
                console.log(data)
                const token = data.token
                localStorage.setItem("token", token)
                axios.defaults.headers.common['Authorization'] = token
                commit('Login', token)
                commit('LoginDetails', data)
                resolve(data);
              }
            })
            .catch((error)=>{
              reject(error);
            });
          })
      },
      
      Register: ({commit}, payload)=>{
          return new Promise((resolve, reject)=>{
            axios.post("/member",payload)
            .then(({data, status})=>{
              if(status === 201){
                commit('RegDetails', payload)
                resolve(data);
              }
            })
            .catch((error)=>{
              reject(error);
            });
          })
      },
      forgotPassword: ({commit},payload)=>{
          return new Promise((resolve, reject)=>{
            axios.post("/forgotpassword",payload)
            .then(({data, status})=>{
              if(status === 200){
                resolve(data);
                commit()

              }
            })
            .catch((error)=>{
              reject(error);
            });
          })
      },
      SetNewPassword: ({commit},payload)=>{
          return new Promise((resolve, reject)=>{
            axios.post("/setnewpassword",payload)
            .then(({data, status})=>{
              if(status === 200){
                resolve(data);
                commit()
              }
            })
            .catch((error)=>{
              reject(error);
            });
          })
      },
      verifyUser: ({commit},payload)=>{
        return new Promise((resolve, reject)=>{
          axios.get(`/verifyuser?username=${payload.username}&code=${payload.code}`)
          .then(({data, status})=>{
            if(status === 200){
              resolve(data);
              commit()
            }
          })
          .catch((error)=>{
            reject(error);
          });
        })
      },
      GetUser: ({commit},payload)=>{
        return new Promise((resolve, reject)=>{
          axios.get('/user/'+payload)
          .then(({data, status})=>{
            console.log(data)
            if(status === 200){
              commit('LoginDetails', data)
              resolve(data);
              
              
            }
          })
          .catch((error)=>{
            reject(error);
          });
        })
      },
      AUTH_LOGOUT: ({commit})=>{
        return new Promise((resolve) => {
          localStorage.removeItem("token")
          window.localStorage.removeItem("vuex")          
          // remove the axios default header
          delete axios.defaults.headers.common['Authorization']
          if(localStorage.getItem("vuex")){
            resolve()
          }else{
            resolve()
            commit('Logout')
          }
          
        })
      },
      ChangeEmail: ({commit},payload)=>{
        return new Promise((resolve, reject)=>{
          axios.post("/changeemail",payload)
          .then(({data, status})=>{
            if(status === 200){
              resolve(data);
              commit()
            }
          })
          .catch((error)=>{
            reject(error);
          });
        })
      },
      ChangePassword: ({commit},payload)=>{
        return new Promise((resolve, reject)=>{
          axios.post("/changepassword",payload)
          .then(({data, status})=>{
            if(status === 200){
              resolve(data);
              commit()
            }
          })
          .catch((error)=>{
            reject(error);
          });
        })
      },
      TwoFactorAuth: ({commit},payload)=>{
        return new Promise((resolve, reject)=>{
          axios.post(`/twofactorauth?type=${payload}`)
          .then(({data, status})=>{
            if(status === 200){
              resolve(data);
              commit()
            }
          })
          .catch((error)=>{
            reject(error);
          });
        })
      },
      TwoFactorAuthAuth: ({commit},payload)=>{
        return new Promise((resolve, reject)=>{
          axios.post('/twofactorcode', payload)
          .then(({data, status})=>{
            if(status === 200){
              resolve(data);
              commit()
            }
          })
          .catch((error)=>{
            reject(error);
          });
        })
      },
      Rate: ({commit},payload)=>{
        return new Promise((resolve, reject)=>{
          axios.post('/rate', payload)
          .then(({data, status})=>{
            if(status === 200){
              resolve(data);
              commit()
            }
          })
          .catch((error)=>{
            reject(error);
          });
        })
      },
    }
}